import { NFT_DAO_UTILS_ABI } from '@/abis/nft-dao-utils';
import { NFT_DAO_V2_MAIN_ABI } from '@/abis/nft-dao-v2-main';

export const NFT_DAO_UTILS_CONTRACT_CONFIG = {
	address: (import.meta.env.VITE_NFT_DAO_UTILS_CONTRACT_ADDRESS || '') as `0x${string}`,
	abi: NFT_DAO_UTILS_ABI,
} as const;

/** V2 utils — same read interface as V1 when pointed at the V2 utils deployment */
export const NFT_DAO_V2_UTILS_CONTRACT_CONFIG = {
	address: (import.meta.env.VITE_NFT_DAO_V2_UTILS_CONTRACT_ADDRESS || '') as `0x${string}`,
	abi: NFT_DAO_UTILS_ABI,
} as const;

export const NFT_DAO_V2_MAIN_CONTRACT_CONFIG = {
	address: (import.meta.env.VITE_NFT_DAO_V2_CONTRACT_ADDRESS || '') as `0x${string}`,
	abi: NFT_DAO_V2_MAIN_ABI,
} as const;

export type NftDaoUtilsContractConfig =
	| typeof NFT_DAO_UTILS_CONTRACT_CONFIG
	| typeof NFT_DAO_V2_UTILS_CONTRACT_CONFIG;
